
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/seminovos",
      function () {
        return require("private-next-pages/seminovos.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/seminovos"])
      });
    }
  